const directive = Vue => {
    // 表格滚动加载

    Vue.directive("loadmore", {
        bind (el, binding) {
            const selectWrap = el.querySelector(".el-table__body-wrapper");
            selectWrap.addEventListener("scroll", function () {
                let sign = 10;
                const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
                if (scrollDistance <= sign) {
                    binding.value();
                }
            });
        }
    })

    /**
     *  v-enter-number
     *  限制input输入框只能输入正整数
     *  v-enter-number.float="2" (保留两位小数)
     */
    Vue.directive("enterNumber", {
        insert (el, binding, vnode) {
            let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
            if (ele) {
                ele.addEventListener("input", Vue.prototype.$util.onInput(ele, binding, vnode));
            }
        },
        update (el, binding, vnode) {
            let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
            if (ele) {
                ele.addEventListener("input", Vue.prototype.$util.onInput(ele, binding, vnode));
            }
        },

        unbink (el, binding, vnode) {
            let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
            if (ele) {
                ele.removeEventListener("input", Vue.prototype.$util.onInput(ele, binding, vnode));
            }
        }
    });


    // 覆盖element默认loading
    Vue.directive("loading", {
        inserted (el) { }
    });

}


export default directive
